import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { X } from "lucide-react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/typedHooks";
import { setUser } from "../../redux/modules/userSlice";
import { updateModalCreateFirstPostAPI } from "../../api/userApi";
import { showToast } from "../../utils/toast";
import type { UserInterface } from "../../types/user";

interface CreateFirstPostModalProps {
  open: boolean;
  onClose: () => void;
}

const CreateFirstPostModal: React.FC<CreateFirstPostModalProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );

  const updateUserModalState = (value: boolean) => {
    if (currentUser) {
      dispatch(
        setUser({
          ...currentUser,
          isModalCreateFirstPost: value,
        } as any)
      );
    }
  };

  const handleClose = async () => {
    try {
      await updateModalCreateFirstPostAPI(false);
      updateUserModalState(false);
      onClose();
    } catch (error) {
      // console.error("Failed to update modal setting:", error);
      onClose();
    }
  };

  const handleSkip = async () => {
    try {
      await updateModalCreateFirstPostAPI(false);
      updateUserModalState(false);
      onClose();
    } catch (error) {
      // console.error("Failed to update modal setting:", error);
      // showToast("Failed to update settings", "error");
    }
  };

  const handleCreatePost = async () => {
    try {
      await updateModalCreateFirstPostAPI(false);
      updateUserModalState(false);
      onClose();
      history.push("/post-creator");
    } catch (error) {
      // console.error("Failed to update modal setting:", error);
      // showToast("Failed to update settings", "error");
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disablePortal
      disableEnforceFocus
      disableScrollLock
      BackdropProps={{
        onClick: handleClose,
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
      style={{
        display: "flex",
        alignItems: isMobile ? "flex-end" : "center",
        justifyContent: "center",
        padding: isMobile ? "16px 16px 40px 16px" : "16px",
      }}
    >
      <Box
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
        }}
        style={{
          maxWidth: "550px",
          width: "100%",
          backgroundColor: "#1a1a1a",
          borderRadius: "12px",
          padding: isMobile ? "28px 16px" : "32px",
          position: "relative",
          outline: "none",
        }}
      >
        {/* Header with title and close icon */}
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography
            style={{
              fontSize: isMobile ? "16px" : "32px",
              fontWeight: 700,
              color: "white",
              lineHeight: 1.2,
            }}
          >
            Let's create your first post!
          </Typography>
          <IconButton
            onClick={handleClose}
            style={{
              color: "white",
              padding: "4px",
              marginLeft: "16px",
            }}
            size="small"
          >
            <X size={isMobile ? 20 : 24} />
          </IconButton>
        </Box>

        {/* Subtitle */}
        <Typography
          style={{
            fontSize: isMobile ? "12px" : "16px",
            color: "#ccc",
            marginBottom: "24px",
            lineHeight: 1.5,
          }}
        >
          Share your thoughts and media
        </Typography>

        {/* Buttons */}
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleSkip}
            style={{
              borderColor: "#FE5A97",
              color: "#FE5A97",
              padding: "12px 24px",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 600,
              flex: 1,
            }}
          >
            Skip
          </Button>
          <Button
            variant="contained"
            onClick={handleCreatePost}
            style={{
              backgroundColor: "#FE5A97",
              color: "white",
              padding: "12px 24px",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 600,
              flex: 1,
            }}
          >
            Create Post
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateFirstPostModal;

